module.exports = __webpack_public_path__ + "media/images/banner-hotel-lp-zh-hans-c44d911b51f2c23a8f10b99a046203d4.jpg";